import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesRefazer.vue?vue&type=template&id=a59ab234"
import script from "./LicitacaoAtualizacaoAcoesRefazer.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesRefazer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports